import { useQuery } from "@tanstack/react-query";

import { n8nInstance } from "@shared/services";
import { PAYFAC_QUERIES } from "./queries";

import { convertObjectToCamelCase } from "@shared/helpers";

import type { ISellerPlanWithPagination } from "@payfac/types";

const URLS = {
  companies: (companyId: string) =>
    `e4df297e-a963-4936-811f-330a1fb91bae/prd/v1/companies/${companyId}/sellers`,
};

const api = n8nInstance({
  enableBearerToken: true,
  enableXTokenApi: true,
});

export const useGetSellerPlan = ({
  companyId,
  sellerId,
}: {
  companyId?: string;
  sellerId?: string;
}) => {
  const getSellerPlan = async (): Promise<{
    success: boolean;
    message: string;
    data?: ISellerPlanWithPagination;
  }> => {
    try {
      const { data } = await api.get(`${URLS.companies(companyId)}`, {
        params: {
          ...(sellerId ? { id: sellerId } : {}),
          negate: false,
          limit: 1,
          page: 1,
          webapp: true,
        },
      });

      return {
        success: true,
        message: "Plano do seller encontrado com sucesso!",
        data: convertObjectToCamelCase(data) as ISellerPlanWithPagination,
      };
    } catch (error: any) {
      return {
        success: false,
        message:
          error?.response?.data?.message ||
          error?.response?.message ||
          "Erro ao buscar o plano do seller!",
      };
    }
  };

  return useQuery({
    queryKey: [PAYFAC_QUERIES.SELLER_PLAN, companyId, sellerId],
    queryFn: () => getSellerPlan(),
    enabled: !!companyId,
  });
};
